import {API_ROOT, SUCCESS_CODE, DEFAULT_NETWORK_TIMEOUT, TOKEN_EXPIRE_CODE} from "../config";

import axios from 'axios'


const http = axios.create({
    baseURL: API_ROOT,
    timeout: DEFAULT_NETWORK_TIMEOUT
});

axios.defaults.headers.get['Cache-Control'] = 'no-cache';

http.interceptors.request.use(config => {
    if (config.method==='get') {
        if (config.params) {
            config.params.account = 'gh_b88b0ae178c7'
        } else {
            config.params = { account: 'gh_b88b0ae178c7' }
        }
    }
    if (config.method==='post') {
        if (config.data) {
            config.data.account = 'gh_b88b0ae178c7'
        } else {
            config.data = { account: 'gh_b88b0ae178c7' }
        }
    }
    return config
});

http.interceptors.response.use(response => {
        // console.log('RESP', response);
        return new Promise(function (resolve, reject) {
            if (response.status === 200 && response.data.success === SUCCESS_CODE) {
                resolve(response.data)
            } else {
                reject(response.data)
            }
        })
    }, error => {
        if (!error.response) {
            error.response = {}
        }
        if (!error.response.data) {
            error.response.data = {}
        }
        if (error.response.status === TOKEN_EXPIRE_CODE) {
            error.response.data.tryRefresh = true
        }
        return Promise.reject(error.response.data)
    }
);

export default http
